import React from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import Dimensions from 'react-dimensions';
import moment from 'moment';
import {
	LineChart,
	Line,
	XAxis,
	YAxis,
	Tooltip,
	CartesianGrid
} from 'recharts';
import {
	Grid,
	Card
} from 'semantic-ui-react';

import ChatedToggle from '../../components/toggle';
import ChatedCard from '../../components/card';
import Loading from '../../components/loading';
import Tab from '../../components/tab';
import Graph from '../../helpers/graph';
import GA from '../../helpers/ga';

import {
	getTemplateConnectionStatistics,
	resetAlertMessage,
	reset
} from './actions';

import {getAbandonedCartTemplateConnection} from '../dashboard-emails-settings-page/actions';

const PAGE_VIEW_NAME = '/dashboard/emails/statistics';
const COLORS = {
	Main: {
		Request: '#246201',
		Delivered: '#BCD514',
		Opened: '#028690',
		Clicked: '#59C1CA',
		Bounces: '#C042BE',
		SpamReports: '#E04427'
	},
	Sub: {
		Delivered: '#6a780b',
		Opened: '#01282b',
		Clicked: '#2e878f',
		Bounces: '#752774',
		SpamReports: '#8d2714'
	}
};

export class EmailStatisticsPage extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			showWeek: false
		};

		props.getAbandonedCartTemplateConnection('abandoned_cart');
	}

	componentDidMount() {
		GA.sendPageView(PAGE_VIEW_NAME);
	}

	componentWillReceiveProps (nextProps) {
		if (_.isNil(nextProps.templateConnection)) {
			nextProps.getAbandonedCartTemplateConnection('abandoned_cart');
			return;
		}

		if (_.isNil(nextProps.templateConnectionStatistics)) {
			const endDate = moment().format('YYYY-MM-DD');
			const startDate = moment().subtract(29, 'days').format('YYYY-MM-DD');
			nextProps.getTemplateConnectionStatistics(nextProps.templateConnection._id, startDate, endDate);
			return;
		}
	}

	getValue = (value) => {
		if (value) {
			GA.sendEvent(PAGE_VIEW_NAME, 'click', 'WeekButton', 1);
		} else {
			GA.sendEvent(PAGE_VIEW_NAME, 'click', 'MonthButton', 1);
		}

		this.setState({
			showWeek: value
		});
	}

	render() {
		const {templateConnectionStatistics,templateConnection,containerHeight,containerWidth} = this.props;
		if (_.isNil(templateConnectionStatistics) || _.isNil(templateConnection)) {
			return <Loading />;
		}

		let statistics = [];

		if (this.state.showWeek) {
			statistics = _.takeRight(templateConnectionStatistics, 7);
		} else {
			statistics = templateConnectionStatistics;
		}

		const summary = Graph.summary(statistics);
		const paneHeight = containerHeight; // 70px is size of first row;
		const paneWidth = containerWidth;

		return (
			<Tab.Pane
				containerHeight={ paneHeight }
				padding={ 15 }
			>
				<Grid padded>
					<Grid.Row>
						<Grid.Column width={13}><h1>Hello! Here's your recent email activity.</h1></Grid.Column>
						<Grid.Column width={3} className='center'><ChatedToggle leftText='Wk' rightText='Mo' isLeftActive={this.getValue} style={{marginTop: '10px'}}/></Grid.Column>
					</Grid.Row>
				</Grid>
				<div style={{margin: 30}}>
					<Card.Group className='centered' itemsPerRow={6}>
						<ChatedCard
							title='Requests'
							text={`${summary.requests}`}
							color={COLORS.Main.Request}
						/>
						<ChatedCard
							title='Delivered'
							text={`${summary.delivered.percentage}%`}
							subtext={`${summary.delivered.total}`}
							color={COLORS.Main.Delivered}
							subcolor={COLORS.Sub.Delivered}
						/>
						<ChatedCard
							title='Opened'
							text={`${summary.opens.percentage}%`}
							subtext={`${summary.opens.total}`}
							color={COLORS.Main.Opened}
							subcolor={COLORS.Sub.Opened}
						/>
						<ChatedCard
							title='Clicked'
							text={`${summary.clicks.percentage}%`}
							subtext={`${summary.clicks.total}`}
							color={COLORS.Main.Clicked}
							subcolor={COLORS.Sub.Clicked}
						/>
						<ChatedCard
							title='Bounces'
							text={`${summary.bounces.percentage}%`}
							subtext={`${summary.bounces.total}`}
							color={COLORS.Main.Bounces}
							subcolor={COLORS.Sub.Bounces}
						/>
						<ChatedCard
							title='Spam Reports'
							text={`${summary.spam_reports.percentage}%`}
							subtext={`${summary.spam_reports.total}`}
							color={COLORS.Main.SpamReports}
							subcolor={COLORS.Sub.SpamReports}
						/>
					</Card.Group>
				</div>
				<LineChart width={paneWidth-50} height={379} data={statistics} margin={{top: 5, right: 40, left: 5, bottom: 5}}>
					<XAxis dataKey='name'/>
					<YAxis/>
					<CartesianGrid stroke='#eee' strokeDasharray='10 10' vertical={false}/>
					<Tooltip wrapperStyle={{top: 0, left: 0, width: 224, height: 300}} animationDuration={400}/>
					<Line type='linear' dot={false} dataKey='bounces' stroke={COLORS.Main.Bounces} />
					<Line type='linear' dot={false} dataKey='clicks' stroke={COLORS.Main.Clicked} />
					<Line type='linear' dot={false} dataKey='delivered' stroke={COLORS.Main.Delivered} />
					<Line type='linear' dot={false} dataKey='spam_reports' stroke={COLORS.Main.SpamReports} />
					<Line type='linear' dot={false} dataKey='opens' stroke={COLORS.Main.Opened} />
					<Line type='linear' dot={false} dataKey='requests' stroke={COLORS.Main.Request} />
				</LineChart>
			</Tab.Pane>
		);
	}
}

export function mapsStateToProps ( state ) {
	return {
		meta: state.dashboardEmailsStatisticsReducer.meta,
		templateConnectionStatistics: state.dashboardEmailsStatisticsReducer.templateConnectionStatistics,
		templateConnection: state.dashboardEmailsSettingsReducer.templateConnection
	};
}

export function mapsDispatchToProps ( dispatch ) {
	return {
		getAbandonedCartTemplateConnection (templateSlug) {
			dispatch( getAbandonedCartTemplateConnection(templateSlug) );
		},

		getTemplateConnectionStatistics (id, startDate, endDate) {
			dispatch( getTemplateConnectionStatistics(id, startDate, endDate) );
		},

		resetAlertMessage () {
			dispatch( resetAlertMessage() );
		},

		reset() {
			dispatch( reset() );
		}
	};
}

export default connect(mapsStateToProps, mapsDispatchToProps)( Dimensions()(EmailStatisticsPage) );



// WEBPACK FOOTER //
// ./src/containers/dashboard-emails-statistics-page/email-statistics-page.js